import { urls } from "../../constants";
import { axiosService } from "../axios.service";

const packCategoryService = {
  getAll: () => axiosService.get(urls.settings.packCategories).then(v => v.data),
  getAllLite: () => axiosService.get(`${urls.settings.packCategories}/lite`).then(v => v.data),
  create: (data) => axiosService.post(urls.settings.packCategories, data).then(v => v.data),
  updateById: (id, data) => axiosService.patch(`${urls.settings.packCategories}/${id}`, data).then(v => v.data),
  deleteById: (id) => axiosService.destroy(`${urls.settings.packCategories}/${id}`),
};

export { packCategoryService };
